module.exports = __webpack_public_path__ + "img/Avatar-95.7bdcc75c.svg";